import React from 'react';

// Renders **bold** segments inline. Segments are static text so a position-qualified
// key is stable; plain `i` alone would collide semantically with reordering rules.
export const Inline = ({ text }) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) => {
    const key = `${i}:${part}`;
    return part.startsWith('**')
      ? <strong key={key} className="font-bold text-[#143160]">{part.slice(2, -2)}</strong>
      : <React.Fragment key={key}>{part}</React.Fragment>;
  });

const Stats = ({ items }) => (
  <div className="grid sm:grid-cols-3 gap-4 my-8" data-testid="landing-stats">
    {items.map((s) => (
      <div key={s.label} className="bg-white border border-gold-400/30 rounded-2xl p-6 text-center shadow-[0_2px_14px_rgba(20,49,96,0.06)]">
        <p className="font-serif text-3xl sm:text-4xl text-[#143160]">{s.num}</p>
        <p className="text-sm text-neutral-500 mt-2 leading-snug">{s.label}</p>
      </div>
    ))}
  </div>
);

export const LandingBlock = ({ block }) => {
  switch (block.type) {
    case 'h2':
      return <h2 className="font-serif text-3xl sm:text-4xl text-[#143160] leading-tight">{block.text}</h2>;
    case 'h3':
      return <h3 className="text-xl font-bold text-[#143160] pt-4">{block.text}</h3>;
    case 'stats':
      return <Stats items={block.items} />;
    case 'note':
      return (
        <div className="bg-gold-50 border border-gold-200 border-l-4 border-l-gold-500 rounded-r-xl px-6 py-4 my-6 text-neutral-700 leading-relaxed" data-testid="landing-note">
          <Inline text={block.text} />
        </div>
      );
    case 'list':
      return (
        <ul className="space-y-3">
          {block.items.map((item) => (
            <li key={item} className="flex items-start gap-3 text-lg leading-relaxed text-neutral-700">
              <span className="mt-3 w-2 h-2 rounded-full bg-gold-500 shrink-0"></span>
              <span><Inline text={item} /></span>
            </li>
          ))}
        </ul>
      );
    default:
      return <p className="text-lg leading-relaxed text-neutral-700"><Inline text={block.text} /></p>;
  }
};
